<template lang="pug">
div.h-100
  div.result-list.h-100
    div
      forms-options-selector-vue(
        :options = "options",
        @update_option="filterListElements",
        :preSelectedOption='currentOption',
        :disableOptions="searching"
        )
    h5.px-3.pt-3.bgGray.mb-0 {{ t("components.forms.navigation_list.filter_letter") }}
    forms-letter-selector-vue(
      :characters = "filteredCharacters",
      @update_letter="filterResultsByLetter",
      :preSelectedLetter="currentLetter",
      :allow_click_on_empty_letter='false'
    )
    list-by-input-search-vue(
      :listElements="listElements"
      :hasExtraFilter="hasExtraFilter"
      @perform:search="sendSearch"
      @toggle:hasInput="toggleHasInput"
    )
    navigation-list-elements-vue(
      ref='navigationListElements'
      :preselectedFilters="searchProps['preselectedFilters']",
      :filteredListElements="filteredListElements",
      :filterName="searchProps['filterName']",
      :inputSearchGroups="searchProps['inputSearchGroups']",
      :facetNames="facetNames",
      :hasInput="hasInput",
      :currentElements="currentElements",
      :currentLetter="currentLetter",
      :currentOption="currentOption",
      :optionFilterName="optionFilterName"
    )
</template>

<script>
import mixins from "common/mixins.js";
import { mapState, mapMutations } from 'vuex';

export default {
  name: "forms-navigation-list-vue",
  props: {
    searchProps: { type: Object, default: () => {}},
    facetsByInitialByDomain: { type: Object, default: () => {} },
    facetsByInitial: { type: Object, default: () => {} },
    facetNames: { type: Object, default: () => {} },
    options: { type: Array, default: () => [] },
    preSelectedOption: { type: String, default: '' },
    optionFilterName: { type: String, default: '' },
    characters: { type: Array, default: () => [] }
  },
  components: {
    "navigation-list-elements-vue": () => import(
      /* webpackChunkName: "[request]" */ "components/forms/NavigationListElements.vue"
    ),
    "list-by-input-search-vue": () => import(
      /* webpackChunkName: "[request]" */ "components/forms/ListByInputSearch"
    ),
  },
  data() {
    return {
      currentLetter: this.searchProps.navigation.last_selected_letter || '',
      currentOption: this.preSelectedOption,
      currentSearch: '',
      valueInput : this.searchProps.navigation.last_search_text || '',
      filteredCharacters: this.characters,
      optionsObject: {},
      filteredListElements: [],
      hasInput: false
    }
  },
  mixins: [mixins.filters, mixins.translate, mixins.regex_utils],
  computed: {
    listElements(){
      return Object.values(this.currentElements)
        .flat()
        .map((elementId) => ({
          name: this.facetNames[elementId],
          id: elementId,
        }))
    },
    currentElements(){
      if(this.currentOption == '')
        return this.facetsByInitial
      else
        return this.facetsByInitialByDomain[this.currentOption]
    },
    hasExtraFilter(){
      return this.currentLetter.length > 0
    },
    ...mapState("search", ['searching'])
  },
  methods: {
    sendSearch(id){
      this.$refs.navigationListElements.search(id)
    },
    toggleHasInput(value){
      if(value)
        this.currentLetter = ''
      this.hasInput = value
    },
    filterListElements(option) {
      if (option === '')
        return;

      this.currentOption = option;
      this.charactersByListElementsValues();
      this.resetGroupResults()
      this.resetFilters()
    },
    filterResultsByLetter(letter) {
      this.valueInput = "";
      this.currentLetter = letter;
    },
    charactersByListElementsValues() {
      if (Object.keys(this.currentElements).length === 0 || this.characters.length === 0) {
        return
      }
      const valuesInitials = new Set(
        Object.values(
          this.currentElements
          ).map(element => element[0][0].toUpperCase()
        ));

      this.filteredCharacters = this.characters.map(character => {
        character.has_results = valuesInitials.has(character.letter)
        return character;
      });
    },
    ...mapMutations(
      "search", ['resetGroupResults','resetFilters', 'setLastSelectedLetter']
    ),
  },
  watch: {
    currentLetter(letter) {
      this.setLastSelectedLetter(letter)
    },
  },
  mounted() {
    if(this.preSelectedOption != '')
      this.filterListElements(this.preSelectedOption)
  }
}
</script>
